import React from "react";
import { BarChart, LineChart, DonutChart, Card, Text } from "@tremor/react";

const ChartWidget = ({ widget }) => {
  const rows = Array.isArray(widget.data) ? widget.data : [];
  const chartType = widget.props?.chart_type || "bar";
  const categories = rows.length ? Object.keys(rows[0]).filter((k) => k !== "group") : [];

  if (!rows.length) {
    return (
      <Card>
        <Text>{widget.title}</Text>
        <Text className="mt-2 text-gray-400">No data.</Text>
      </Card>
    );
  }

  if (chartType === "donut") {
    return (
      <Card>
        <Text>{widget.title}</Text>
        <DonutChart className="mt-4" data={rows} category={categories[0]} index="group" />
      </Card>
    );
  }

  const ChartComponent = chartType === "line" ? LineChart : BarChart;
  return (
    <Card>
      <Text>{widget.title}</Text>
      <ChartComponent className="mt-4" data={rows} index="group" categories={categories} />
    </Card>
  );
};

export default ChartWidget;
